import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-51faaabc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Estado de mi cuenta ProDev", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Gracias por formar parte de nuestra comunidad,", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "top" }, "¡Eleva tu formación al próximo nivel!", -1))
const _hoisted_5 = { class: "cards" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Mi plan de suscripción", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Estado:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Tipo de suscripción:", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Fecha de inicio:", -1))
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-close" }, "Cancelar Suscripción", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 6,
  class: "info"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-close" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/prodev/registro" }, "Activar Suscripción")
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"30px"} }, "Tu apoyo ayuda a cubrir los costos asociados con el desarrollo y mantenimiento de recursos de aprendizaje de alta calidad, programas de apoyo, y una infraestructura sólida para facilitar el crecimiento y éxito de todos los miembros.", -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import PaypPalService from '@/services/PayPalService'
import { onMounted, ref, Ref } from 'vue';
import { useAuth } from '@/store/useAuth';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusCountView',
  setup(__props) {

const service = new PaypPalService()
const data:Ref<any> = ref({})
const store = useAuth()
const loading = ref(true)
const nextPayment = ref('')

onMounted(async() => {
  loading.value = true
  if(!store.token) {
    return
  }
  data.value = await service.checkSub(store.token)
  if(data?.value.plan_id == main.PLAN_ID_MONTH_NOT_FREE) {
    // mensual
    let start_year = data.value.create_time.slice(0,4)
    let start_month = data.value.create_time.slice(5,7)
    let start_day = data.value.create_time.slice(8,10)

    let next_month = parseInt(start_month) +1;
    if(next_month >=13) {
      start_month = '01'
      let next_year = parseInt(start_year) +1
      start_year = next_year.toString()
    } else {
      start_month = next_month.toString()
    }

    nextPayment.value = start_year + '-' + start_month + '-' + start_day
    
  } else {
    // anual
    let start_year = data.value.create_time.slice(0,4)
    let start_month = data.value.create_time.slice(5,7)
    let start_day = data.value.create_time.slice(8,10)

    let next_year = parseInt(start_year) +1
    start_year = next_year.toString()

    nextPayment.value = start_year + '-' + start_month + '-' + start_day

  }
  loading.value = false
})


const cancelSub = async () => {
  if(!store.token) {
    return;
  }
  var reason = prompt("Lamentamos que te vayas :( . Por favor indícanos el motivo de tu cancelación. Este paso es irreversible.");
  if (reason != null) {
      const response = await service.cancelSub(store.token, reason)
      window.location.href = "/estado-cuenta-prodev"
  }
}

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("p", null, _toDisplayString(data.value.status), 1),
            _hoisted_9,
            (data.value.plan_id == 'P-96L394980W065412PMXOHYLI')
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Mensual"))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, "Anual")),
            _hoisted_12,
            (!loading.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(data.value.create_time.slice(0,10)), 1))
              : _createCommentVNode("", true),
            (data.value.status == 'ACTIVE')
              ? (_openBlock(), _createElementBlock("h5", _hoisted_14, "Próximo pago:"))
              : _createCommentVNode("", true),
            (data.value.status == 'ACTIVE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (data.value.plan_id == 'P-96L394980W065412PMXOHYLI')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(nextPayment.value) + " (4,99€)", 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(nextPayment.value) + " (29,90€)", 1))
                ]))
              : _createCommentVNode("", true),
            (data.value.status == 'ACTIVE')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  class: "close",
                  onClick: cancelSub
                }, _hoisted_19))
              : (_openBlock(), _createElementBlock("button", _hoisted_20, _hoisted_22))
          ]),
          _hoisted_23
        ])
      ])
    ]),
    _: 1
  }))
}
}

})